import { createTypes, createAction } from 'lib/action'

const LOAD_DATA_SILO_STOCK = createTypes('loadDataSiloStock', 'load')
const UPDATE_REQUIRE_STOCK = createTypes('updateRequireStock', 'update')
const LOAD_LOCATION_LISTS = createTypes('loadLocationLists', 'load')
const GET_DATA_STOCK_DETAIL = createTypes('getDataStockDetail', 'get')
const GET_DATA_STOCK_BALANCE = createTypes('getDataStockBalance', 'get')
const CREATE_STOCK_BALANCE = createTypes('createstockbalance', 'create')
const UPDATE_STOCK_BALANCE = createTypes('updatestockbalance', 'update')
const MATERIAL_STOCK_EXPORT_STOCK_BALANCE = createTypes(
  'materialStockExportStockBalance',
  'export'
)

const MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING = createTypes(
  'materialStockGetDataPlantSiloSetting',
  'get'
)

const MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING = createTypes(
  'materialStockUpdateDataPlantSiloSetting',
  'update'
)

const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}
// load data silo stock
const loadDataSiloStock = {
  request: (data, loading) =>
    createAction(LOAD_DATA_SILO_STOCK.REQUEST, { data, loading }),
  success: (lists) => createAction(LOAD_DATA_SILO_STOCK.SUCCESS, { lists }),
  failure: () => createAction(LOAD_DATA_SILO_STOCK.FAITLURE),
}
// update data silo stock
const updateRequireStock = {
  request: (data, loading) =>
    createAction(UPDATE_REQUIRE_STOCK.REQUEST, { data, loading }),
  success: (res) => createAction(UPDATE_REQUIRE_STOCK.SUCCESS, { res }),
  failure: () => createAction(UPDATE_REQUIRE_STOCK.FAILURE),
}
// load location list
const loadLocationLists = {
  request: (data) => createAction(LOAD_LOCATION_LISTS.REQUEST, { data }),
  success: (lists) => createAction(LOAD_LOCATION_LISTS.SUCCESS, { lists }),
  failure: () => createAction(LOAD_LOCATION_LISTS.FAILURE),
}
// get data stock detail
const getDataStockDetail = {
  request: (data) => createAction(GET_DATA_STOCK_DETAIL.REQUEST, { data }),
  success: (lists) => createAction(GET_DATA_STOCK_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(GET_DATA_STOCK_DETAIL.FAILURE),
}

// get data stock balance
const getDataStockBalance = {
  request: (data) => createAction(GET_DATA_STOCK_BALANCE.REQUEST, { data }),
  success: (lists) => createAction(GET_DATA_STOCK_BALANCE.SUCCESS, { lists }),
  failure: () => createAction(GET_DATA_STOCK_BALANCE.FAILURE),
}

// create stock balance
const createStockBalance = {
  request: (data, loading) =>
    createAction(CREATE_STOCK_BALANCE.REQUEST, { data, loading }),
  success: (res) => createAction(CREATE_STOCK_BALANCE.SUCCESS, { res }),
  failure: () => createAction(CREATE_STOCK_BALANCE.FAITLURE),
}

// update stock balance
const updateStockBalance = {
  request: (data, loading) =>
    createAction(UPDATE_STOCK_BALANCE.REQUEST, { data, loading }),
  success: (res) => createAction(UPDATE_STOCK_BALANCE.SUCCESS, { res }),
  failure: () => createAction(UPDATE_STOCK_BALANCE.FAITLURE),
}

// export stock balance
const materialStockExportStockBalance = {
  request: (data, loading) =>
    createAction(MATERIAL_STOCK_EXPORT_STOCK_BALANCE.REQUEST, {
      data,
      loading,
    }),
  success: (res) =>
    createAction(MATERIAL_STOCK_EXPORT_STOCK_BALANCE.SUCCESS, { res }),
  failure: () => createAction(MATERIAL_STOCK_EXPORT_STOCK_BALANCE.FAITLURE),
}

// get data plant silo stock
const materialStockGetDataPlantSiloSetting = {
  request: (data) =>
    createAction(MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING.REQUEST, { data }),
  success: (lists) =>
    createAction(MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING.SUCCESS, { lists }),
  failure: () =>
    createAction(MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING.FAILURE),
}

// update data plant silo stock
const materialStockUpdateDataPlantSiloSetting = {
  request: (data) =>
    createAction(MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING.FAILURE),
}

export {
  LOAD_DATA_SILO_STOCK,
  loadDataSiloStock,
  UPDATE_REQUIRE_STOCK,
  updateRequireStock,
  LOAD_LOCATION_LISTS,
  loadLocationLists,
  GET_DATA_STOCK_DETAIL,
  getDataStockDetail,
  GET_DATA_STOCK_BALANCE,
  getDataStockBalance,
  CREATE_STOCK_BALANCE,
  createStockBalance,
  UPDATE_STOCK_BALANCE,
  updateStockBalance,
  MATERIAL_STOCK_EXPORT_STOCK_BALANCE,
  materialStockExportStockBalance,
  MATERIAL_STOCK_GET_DATA_PLANT_SILO_SETTING,
  materialStockGetDataPlantSiloSetting,
  MATERIAL_STOCK_UPDATE_DATA_PLANT_SILO_SETTING,
  materialStockUpdateDataPlantSiloSetting,
  REMOVE_LISTS,
  removeLists,
}
